
import Vue from 'vue'
import Components from "./components";
import EventBus from './utils/event-bus';
import * as scrll from './funcs.js';
import Adsense from 'vue-google-adsense/dist/Adsense.min.js'
import 'lazysizes';
import objectFitImages from 'object-fit-images';

Vue.use(require('vue-script2'))
Vue.use(Adsense)

new Vue({
  el: "#app",
  delimiters: ["${", "}"],
  data: {

    navExpand: false,

    searchDisplay: false,
    searchAdvanced: false,
    searchActive: false,
    searchParams: {},
    searchSummary: '',
    searchSuggestions: false,

    showSuggestions: false,
    showDiscuss: false,
    
  },
  methods: {

    navToggle(e) {
      if (this.searchDisplay) {
        this.navExpand = false;
        EventBus.$emit('SELECTOR_CLOSEALL');
      } else {
        this.navExpand = !this.navExpand;
      }
      if (this.navExpand && breakpointMin('teen')) {
        $('.mega a').first().focus();
      }
      this.searchDisplay = false;
      e.preventDefault();
      return false
    },

    searchToggle(e) {
      this.searchDisplay = !this.searchDisplay;
      EventBus.$emit('SEARCH_DISPLAY_UPDATE', this.searchDisplay);
      this.searchSuggestions = false;
      // this.$refs.keywords.focus();
      $('[name="keywords"]').focus().addClass('s_highlight');
      setTimeout(function(){ $('[name="keywords"]').removeClass('s_highlight'); }, 500);

      e.preventDefault();
      return false
    },

    advSearchToggle(e) {
      this.searchSuggestions = false;
      this.searchAdvanced = !this.searchAdvanced;
      EventBus.$emit('SEARCH_ADVANCED_UPDATE', this.searchAdvanced);
      e.preventDefault();
      return false
    },

    suggestionsToggle(e) {
      this.searchSuggestions = !this.searchSuggestions;
      this.searchAdvanced = false;
      e.preventDefault();
      return false
    },

    clearSearch(e) {
      EventBus.$emit('SEARCH_CLEAR');
      e.preventDefault();
      return false
    },

    updateSearchSummary() {
      var theLabel = 'Search: ';
      var sep = '';
      var maxChars = 23;
      var extrasCount = 0;
      // console.log(this.searchParams);
      // console.log('^^^');
      Object.keys(this.searchParams).forEach(key => {
        var thisObj = this.searchParams[key];
        if (thisObj.length && Array.isArray(thisObj)) {
          for (var i = 0; i < thisObj.length; i++) {
            // if (thisObj[i]['selected']) {
              var newLabel = theLabel + sep + thisObj[i]['name'];
              if (newLabel.length <= maxChars) {
                theLabel += sep + thisObj[i]['name'];
              } else {
                extrasCount ++;
              }
              sep = ', ';
              this.searchActive = true;
            // }
          }
        } else if (thisObj.length) {
          theLabel += sep + '"' + thisObj + '"';
          sep = ', ';
          this.searchActive = true;
        }
      });
      if (extrasCount) {
        theLabel += ' + ' + (extrasCount) + ' more';
      }
      if (theLabel == 'Search: ') {
        this.searchActive = false;
        theLabel = 'Find a game';
      }
      this.searchSummary = theLabel;

      if ((this.searchParams['team'] &&
          this.searchParams['team'].length) ||
          (this.searchParams['cost'] &&
          this.searchParams['cost'].length) ||
          (this.searchParams['duration'] &&
          this.searchParams['duration'].length) ||
          (this.searchParams['messy'] &&
          this.searchParams['messy'].length)
          ) {
        this.searchAdvanced = true;
      }
    },

  },
  mounted() {

    EventBus.$on('SEARCH_UPDATE', (fieldName, liveOptions) => {
      this.$set(this.searchParams, fieldName, liveOptions);
      this.updateSearchSummary();
    });

    EventBus.$on('SEARCH_SUBMIT', (searchId) => {
      // console.log($('form[data-id="' + searchId + '"] input[type="submit"]'));
      // $('form[data-id="' + searchId + '"] input[type="submit"]').click();
      return false;
    });

    if (document.getElementById('suggestions')){
      this.searchSuggestions = true;
    }

    if (this.searchParams['duration'] && this.searchParams['duration'].length) {
      this.searchAdvanced = true;
    }

  },
  // created () {

  //   window.addEventListener('scroll', this.handleScroll);
  //   this.handleScroll();

  // },
  // destroyed () {

  //   window.removeEventListener('scroll', this.handleScroll);

  //   window.removeEventListener('scroll', this.handleResize);

  // }
});


//* objectfit polyfill =================================================== */

objectFitImages();


//* is touch device =================================================== */

var isTouch = false;
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
  isTouch = true;
}


//* breakpoints =================================================== */

function breakpointWidth(bp) {
  bpWidth = 768;
  if (bp == 'baby') {
    bpWidth = 479;
  }
  if (bp == 'teen') {
    bpWidth = 600;
  }
  if (bp == 'mama') {
    bpWidth = 768;
  }
  if (bp == 'mega') {
    bpWidth = 1279;
  }
  return bpWidth;
}

function breakpointMax(bp) {
  bpWidth = breakpointWidth(bp);
  if ($(window).width() <= bpWidth) {
    return true;
  } else {
    return false;
  }
  return true;
}

function breakpointMin(bp) {
  bpWidth = breakpointWidth(bp);
  if ($(window).width() > bpWidth) {
    return true;
  } else {
    return false;
  }
  return true;
}


//* cookies =================================================== */

function createCookie(name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function eraseCookie(name) {
  createCookie(name,"",-1);
}


//* scroll to anchor =================================================== */

// all hashtags
$(document).on('click','a[href^="#"]',function(){
  var $this = $(this);
  var aId = $this.attr('href').replace('#','');;
  var $anchorElement = $('[id="' + aId + '"], [name="' + aId + '"], [data-id="' + aId + '"]');
  if ($anchorElement.length > 0) {
    scrll.scrollToAnchor(aId);
    return false;
  }
});

// scroll if hashtag
$(document).ready(function(){
  var hash = window.location.hash.replace('#', '');
  if (hash != '') {
    scrll.scrollToAnchor(hash);
  }
});


//* sticky nav =================================================== */

$(window).scroll(function(){
  var scroll_var = $(window).scrollTop();
  // if (scroll_var > 0) {
  //   $('body').addClass('s_sticky');
  // } else {
  //   $('body').removeClass('s_sticky');
  // }
  if (scroll_var > 0) {
    $('body').addClass('s_off-top');
  } else {
    $('body').removeClass('s_off-top');
  }
  if (scroll_var > 20) {
    $('body').addClass('s_sticky');
  } else {
    $('body').removeClass('s_sticky');
  }
});


//* cat circles =================================================== */

$(document).on('click','.catcircles-link',function(){

  var $track = $(this).parent().find('.catcircles-track');

  var catCircleWidth = $track.find('.catcircle').outerWidth();
  var catCircleGap = parseFloat($('.catcircle').css('margin-right'));
  var catCircleWidthTotal = catCircleWidth + catCircleGap;
  var catTrackWidth = $track.outerWidth();
  var catsVisible = Math.floor(catTrackWidth / catCircleWidth);

  var currentNum = $track.attr('data-id');

  var scrollLeft = $('.catcircles-track').scrollLeft();
  var currentCat = Math.ceil(scrollLeft / catCircleWidthTotal);
  var totalCats = parseFloat($('.catcircle').length);

  var nextCat = currentCat + catsVisible;
  if (nextCat > totalCats) {
    nextCat = totalCats;
  }
  var nextCatX = nextCat * catCircleWidthTotal;

  $track.animate({scrollLeft: nextCatX}, 200);

  return false;
});

$('.catcircles-track').on('scroll', function(){
  // console.log($(this).scrollLeft());
});


//* floating =================================================== */

// setTimeout(function(){
//   if ($('.content-aside.l_float').outerHeight() < ($(window).height() - $('.header').outerHeight())) {
//     $('.content-aside.l_float').width($('.content-aside.l_float').width());
//     $('.content-aside.l_float').css('max-width', $('.content-aside.l_float').width());
//     $('.content-aside.l_float').floatit({
//       top_spacing: 132,
//       bottom_spacing: 40,
//       recalculate: true,
//       limiter: '.footer'
//     });
//   }
// }, 1000);


//* buttons =================================================== */

if ($('.gamepage .gamepage-buttons').length) {

  var headerHeight = $('.header').outerHeight();
  var btnsTop = $('.gamepage .gamepage-buttons').offset().top - headerHeight - 40;
  var btnsBot = $('.footer').offset().top - $('.gamepage-buttons.l_floating').outerHeight() - 40;

  function floatInit() {
    var $btns = $('.gamepage .gamepage-buttons');
    var newWidth = $btns.width();
    var newLeft = $btns.offset().left;
    $('.gamepage-buttons.l_floating').css('width', newWidth).css('left', newLeft);
    headerHeight = $('.header').outerHeight();
    btnsTop = $('.gamepage .gamepage-buttons').offset().top - headerHeight - 40;
    btnsBot = $('.footer').offset().top - $('.gamepage-buttons.l_floating').outerHeight() - 40;
  }

  $(window).scroll(function(){
    var scrollVar = $(window).scrollTop();
    // console.log(scrollVar);
    if (scrollVar > btnsTop) {

      // show hide buttons
      $('.gamepage .gamepage-buttons').addClass('s_hidden');
      $('.gamepage-buttons.l_floating').addClass('s_active');

      // calculate float top
      var floatTop = scrollVar + headerHeight + 40;
      if (scrollVar > btnsBot) {
        floatTop = btnsBot + $('.gamepage-buttons.l_floating').outerHeight() - 60;
      }
      $('.gamepage-buttons.l_floating').css('top', floatTop);


    } else {
      $('.gamepage .gamepage-buttons').removeClass('s_hidden');
      $('.gamepage-buttons.l_floating').removeClass('s_active');
    }
  });

  $(window).resize(function(){
    floatInit();
    setTimeout(function(){
      floatInit();
      $(window).scroll();
    }, 100);

  });

  $(document).ready(function(){
    floatInit();
    $(window).scroll();
  });

}

// $('.gamepage-extra').floatit({
//   top_spacing: 132,
//   bottom_spacing: 40,
//   recalculate: true,
//   limiter: '.footer'
// });


//* cat check =================================================== */

$(document).on('click','.catcheck',function(){
  var $this = $(this);
  $this.toggleClass('s_active');
  if ($this.hasClass('s_active')) {
    $this.find('.catcheck-input').attr('checked', true);
  } else {
    $this.find('.catcheck-input').attr('checked', false);
  }
  $this.find('.catcheck-input').valid();
  return false;
});


//* submit comment =================================================== */

$('#form_comment').validate({
  onfocusout: function (element) {
    $(element).attr('data-edit', 1).valid();
  },
  onkeyup: function(element) {
    if ($(element).attr('data-edit') == '1') {
      $(element).valid();
    }
  },
  onchange: function(element) {
    if ($(element).attr('data-edit') == '1') {
      $(element).valid();
    }
  },
  validClass: 'has-success',
  errorElement: 'p',
  errorClass: 'has-error',
  errorPlacement: function(error,element) {
    error.insertAfter(element.closest('.form-control'));
  },
  focusInvalid: false,
  invalidHandler: function(form, validator) {
    if (!validator.numberOfInvalids())
    return;
    scrll.scrollToPoint($(validator.errorList[0].element).offset().top-50);
  },
  rules: {
    username: 'required',
    comment: 'required',
    useremail: {
      required: true,
      email: true
    },
  },
  messages: {
    useremail: {
      email: 'Please enter a valid email address.'
    },
  }
});


//* submit game =================================================== */

$('#form_submit').validate({
  onfocusout: function (element) {
    $(element).attr('data-edit', 1).valid();
  },
  onkeyup: function(element) {
    if ($(element).attr('data-edit') == '1') {
      $(element).valid();
    }
  },
  onchange: function(element) {
    if ($(element).attr('data-edit') == '1') {
      $(element).valid();
    }
  },
  validClass: 'has-success',
  errorElement: 'p',
  errorClass: 'has-error',
  errorPlacement: function(error,element) {
    error.insertAfter(element.closest('.form-control'));
  },
  focusInvalid: false,
  invalidHandler: function(form, validator) {
    if (!validator.numberOfInvalids())
    return;
    $('html, body').animate({
      scrollTop: $(validator.errorList[0].element).offset().top-50
    }, 500);
  },
  rules: {
    name: 'required',
    // materials: 'required',
    info: 'required',
    // themes: 'required',
    'catid[]': 'required',
    duration: 'required',
    cost: 'required',
    messy: 'required',
    teams: 'required',
    location: 'required',
    submittedby: 'required',
    email: {
      required: true,
      email: true
    },
  },
  messages: {
    email: {
      email: 'Please enter a valid email address.'
    },
  }
});


//* like game =================================================== */

$(document).on('click','[data-action="likeGame"]',function(){
  var $this = $(this);
  $.ajax({
    type: "GET",
    url: '/actions/like/' + $this.attr('data-id') + '/',
    data: {}
  })
  .done(function( msg ) {
    $this.addClass('s_liked s_disabled').attr('disabled', 'disabled');
  });
  return false;
});


//* animate =================================================== */

$(document).ready(function(){
  $('.s_animate').removeClass('s_animate');
});


//* lightbox =================================================== */

$(document).on('click','[data-action="closeLightbox"]',function(){
  $this = $(this);
  $lightbox = $this.parents('.lightbox');
  $lightbox.removeClass('s_active');
  $('body').removeClass('s_lightbox');
  return false;
});

// $(document).on('click','[data-action="share"]',function(){
//   $this = $(this);
//   $('body').addClass('s_lightbox');
//   $('.lightbox[data-id="share"]').addClass('s_active');
//   return false;
// });


//* pinit button =================================================== */

var $pinbtn = $('.pinbtn');

$(document).on('mouseover','.colheader-image, .gamepage-image, .page-image, .page-picture',function(){
  var $this = $(this);
  $pinbtn.css('top', $this.offset().top + 20);
  $pinbtn.css('left', $this.offset().left + 20);
  $pinbtn.addClass('s_active');
});

$(document).on('mouseout','.colheader-image, .gamepage-image, .page-image, .page-picture',function(){
  var $this = $(this);
  $pinbtn.removeClass('s_active');
});

$(document).on('mouseover','.pinbtn',function(){
  $pinbtn.addClass('s_active');
});

$(document).on('click','body',function(){
  $pinbtn.removeClass('s_active');
});


//* lightbox =================================================== */

var lightboxActivate = function(id) {
  $('.lightbox').removeClass('s_active');
  $('.lightbox[data-id="' + id + '"]').addClass('s_active');
  $('.container').addClass('s_lightbox');
  return false;
}

var lightboxClose = function() {
  $('.lightbox').removeClass('s_active');
  $('.container').removeClass('s_lightbox');
  return false;
}

$(document).keyup(function(e) {
  if (e.key === "Escape") {
    lightboxClose();
  }
});

$(document).on('click','[data-action="lightboxActivate"]',function(){
  var id = $(this).attr('data-id');
  lightboxActivate(id);
});

$(document).on('click','[data-action="lightboxClose"]',function(){
  lightboxClose();
});


//* popup =================================================== */

var popupCookie = 'yggPopPin',
popupLightboxId = 'pinterest',
popupPageDelay = 3,
popupDelay = 10,
popupScrollPercentage = 40,
popupExpiry = 21,
startTime = new Date().getTime();

$(window).scroll(function(){
  var scrollY = $(window).scrollTop();
  var docHeight = document.body.clientHeight;
  var scrollPercentage = scrollY / docHeight * 100;
  popupCheck(scrollPercentage);
});

function popupLaunch() {
  lightboxActivate(popupLightboxId)
  createCookie(popupCookie, 1, popupExpiry);
}

function popupCheck(scrollPercentage) {

  if (readCookie(popupCookie) != 1) {

    // if scrolled enough
    if (scrollPercentage > popupScrollPercentage) {

      // get time difference
      var endTime = new Date().getTime();
      var timeDiff = endTime - startTime; //in ms
      timeDiff /= 1000;
      var seconds = Math.round(timeDiff);

      // if enough time passed
      if (seconds > popupDelay) {

        // display the popup
        popupLaunch();

      }

    }

  }

}

function popupInit() {

  if (readCookie(popupCookie) != 1) {
    var hits = readCookie(popupCookie + '_pg');
    if (hits !== null) {
      hits++;
    } else {
      hits = 1;
    }
    createCookie(popupCookie + '_pg', hits, popupExpiry);
  }

}

popupInit();


//* ad block engage =================================================== */

$(document).ready(function () {
  if ($('[id*="waldo-"]').attr('data-processed') !== 'true') {
    $('.engage').attr('hidden', false);
    $('.nw').remove();
  }
});